import get from 'lodash/get';

import { AppRootState } from '../../../store/models/app-state.model';
import { FIRMWARE } from '../../../store/utils/files-names';
import { FirmwareOverviewModel } from '../../models/firmware-overview.model';

export const getFirmwaresSelector = (
  state: AppRootState
): FirmwareOverviewModel[] => get(state, FIRMWARE).firmwares;
